export function checkVuetifySupport() {
  const ua = navigator.userAgent;
  const uaLower = ua.toLowerCase();

  // Helper: semver-ish compare "major.minor.patch"
  const cmp = (a, b) => {
    const pa = String(a).split(".").map(Number);
    const pb = String(b).split(".").map(Number);
    const len = Math.max(pa.length, pb.length);
    for (let i = 0; i < len; i++) {
      const x = pa[i] ?? 0,
        y = pb[i] ?? 0;
      if (x > y) return 1;
      if (x < y) return -1;
    }
    return 0;
  };

  // --- Detect platform quirks first ---
  const isiOS = /iphone|ipad|ipod/.test(uaLower);
  const iOSVersion = (() => {
    // iOS UA contains "OS 15_4" etc
    const m = ua.match(/OS (\d+)[._](\d+)(?:[._](\d+))?/);
    if (!m) return null;
    return [m[1], m[2] ?? "0", m[3] ?? "0"].join(".");
  })();

  // iOS Chrome/Firefox/Edge are just WebKit; treat them as Safari
  const isIosChromiumShell = isiOS && /(crios|edgios)/i.test(ua);
  const isIosFirefoxShell = isiOS && /fxios/i.test(ua);

  // --- Identify desktop-class browsers ---
  let browser = "other";
  let version = "0";

  if (isiOS) {
    browser = "safari"; // WebKit on iOS
    version = iOSVersion || "0";
  } else if (/edg\//i.test(ua)) {
    browser = "edge";
    version = (ua.match(/edg\/([\d.]+)/i) || [])[1] || "0";
  } else if (/firefox\//i.test(ua)) {
    browser = "firefox";
    version = (ua.match(/firefox\/([\d.]+)/i) || [])[1] || "0";
  } else if (/chrome\/([\d.]+)/i.test(ua) && !/opr\//i.test(ua)) {
    browser = "chrome";
    version = (ua.match(/chrome\/([\d.]+)/i) || [])[1] || "0";
  } else if (/safari/i.test(ua) && /version\/([\d.]+)/i.test(ua)) {
    browser = "safari";
    version = (ua.match(/version\/([\d.]+)/i) || [])[1] || "0";
  }

  // --- Vuetify 3 support matrix (full support thresholds) ---
  const min = {
    chrome: "105",
    edge: "105",
    firefox: "121",
    safari: "15.4",
  };

  // If it's an unknown browser, not officially supported
  if (!(browser in min)) {
    return {
      supported: false,
      browser,
      version,
      reason: "not_officially_supported",
    };
  }

  const ok = cmp(version, min[browser]) >= 0;

  // Label iOS shells for clarity in your analytics
  const label =
    isiOS && (isIosChromiumShell || isIosFirefoxShell)
      ? `${browser} (iOS WebKit)`
      : browser;

  return {
    supported: ok,
    browser: label,
    version,
    reason: ok ? undefined : `requires_${browser}_${min[browser]}+`,
  };
}

const { supported, browser, version, reason } = checkVuetifySupport();

if (!supported) {
  console.warn(`Unsupported browser: ${browser} ${version}`, reason);
  alert(
    "Some features may not work optimally in this browser. Consider updating for a better experience.",
  );
  // e.g. show an "update your browser" screen or redirect:
  // window.location.href = "/unsupported-browser";
}
